<template>
  <a-space>
    <a-checkbox
      v-model:checked="isCheckAll"
      class="check-all"
      :disabled="!list.length"
      @change="changeIsCheckAll">
      全选
    </a-checkbox>
    <a-button type="primary" danger @click="clickBatch">
      批量{{ text }} ({{ selectedRows.length }})
    </a-button>
  </a-space>
</template>
<script>
export default {
  props: {
    text: {
      type: String
    },
    list: {
      type: Array,
      default: () => ([])
    },
    selectedRows: {
      type: Array,
      default: () => ([])
    },
    canCommitRepeat: {
      type: Boolean
    }
  },
  data() {
    return {
      isCheckAll: false
    }
  },
  emits: ['click-batch', 'change-check-all'],
  methods: {
    // 点击批量按钮时
    clickBatch() {
      this.$emit('click-batch')
    },
    // 全选 / 取消全选
    changeIsCheckAll() {
      this.list.map(item => {
        if (!item.isMoved || this.canCommitRepeat) item.selected = this.isCheckAll
        else item.selected = false
      })
      this.$emit('change-check-all', this.isCheckAll)
    }
  },
  watch: {
    'selectedRows.length'(count) {
      if (!count) this.isCheckAll = false
    }
  }
}
</script>
<style scoped lang='less'>
  :deep(.check-all) {
    white-space: nowrap;
    border: 1px solid #ddd;
    padding: 4px 6px;
    border-radius: 3px;
    &.ant-checkbox-wrapper-checked {
      border-color: #007fff;
    }
  }
</style>